import React, { useEffect, useMemo, useState } from "react";
import styles from "../Secure.module.scss";
import { useHeader } from "../../../context/HeaderContext";
import { Methods, useFetch } from "../../../hooks/useFetch";
import { User } from "../../../context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import { ComponentLoader } from "../../../components/ComponentLoader";
import { UserListing } from "../profile/components/UserListing";
import { Profile } from "../profile/Profile";
import { StatisticsListings } from "./StatisticsListing";
import { GenericTab, Tabs } from "../components/Tabs";
import { Countries } from "./Countries";

export interface UserListingItem extends User {
  followed: number;
  number_of_bets: number | null | undefined;
  avg_odd: number | null | undefined;
  success_rate: number | null | undefined;
}

const tabsConfiguation: Array<GenericTab> = [
  {
    id: 0,
    label: "COUNTY",
    href: "countries",
    element: <Countries />,
  },
  {
    id: 1,
    label: "LEAGUE",
    href: "followed",
    // element: <TopProfile key="followed" tab="followed" />
  },
  {
    id: 2,
    label: "GAME TYPE",
    href: "all",
    // element: <TopProfile key="all" tab="all" />
  },
];

export const TopProfile: React.FC = () => {
  const { setConfig } = useHeader();
  const params = useParams();

  console.log("usao ovde");
  const [users, setUsers] = useState<Array<UserListingItem> | null>(null);

  const userId = params.id ? parseInt(params.id) : null;

  const [selectedTab, setSelectedTab] = useState<GenericTab | null | undefined>(
    () => {
      if (params && params.tab) {
        const selectedTab = tabsConfiguation.find(
          (tab: GenericTab) => tab.href === params.tab
        );

        if (selectedTab) {
          return selectedTab;
        }
      }

      return tabsConfiguation[0];
    }
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (!params.tab) {
      console.log("ovdeee");
      navigate(`/top/${tabsConfiguation[0].href}`, { replace: true });
    }
  }, [params.tab, navigate]);
  const { makeRequest: fetchUsers } = useFetch(`/api/view_statistics`, {
    method: Methods.GET,
  });

  useEffect(() => {
    const handleFetchUsers = async () => {
      const { data: response } = await fetchUsers();

      setUsers(response.data);
    };

    handleFetchUsers();
  }, []);

  const { title, element, condition } = useMemo(() => {
    if (userId) {
      return {
        title: "User",
        condition: true,
        hideSearchBar: false,
        element: <Profile />,
      };
    }

    return {
      title: "Users",
      hideSearchBar: false,
      condition: users !== null,
      element: (
        <div className={`${styles.searchUsersContent} ${styles.newUser}`}>
          <StatisticsListings
            users={users ? users : ([] as Array<UserListingItem>)}
          />
        </div>
      ),
    };
  }, [users, userId]);

  useEffect(() => {
    setConfig({ title: title });
  }, [title]);

  const handleRenderContent = () => {
    if (!selectedTab) {
      return null;
    }

    return selectedTab.element;
  };

  return (
    <div className={styles.searchUsersWrapper}>
      {/* <Tabs
        tabs={tabsConfiguation}
        updateParentChange={setSelectedTab}
        pageHref="/top"
      />
      {handleRenderContent()} */}

      {condition ? element : <ComponentLoader isLoading />}
    </div>
  );
};
